(function Module() {
	'use strict';
	
	mySynch.controller('EvaluationOverviewV2_0Controller', [
		'$scope',
		'$rootScope',
		'$interval',
		'$q',
		'UtilService',
		'ApiFactory',
		'MySynchFactory',
		'CookieFactory',
		'F360Service',
		'AuditService',
		'F360Constant',
		'$window',
		'$location',
		'$filter',
		'performanceMetricsService',
		'performanceContextService',
		'clientLoggerService',
		function EvaluationOverviewV2_0Controller($s,$rootScope, $interval,$q, utilService, api, MSF,cookies,f360Service, auditService, constant, $window, $location,$filter, perfMetricSvc, perfContextSvc, log) {
			var self = this;
			window.scrollTo(0, 0);
			
			self.isSync = $rootScope.onLine;
			$s.isOnline = $rootScope.onLine;

			self.auditId = auditService.getAuditId($location.url());

			$s.peformanceContext = null;

			$s.auditApiVersion;

			$s.breadcrumbs = f360Service.getReport360Breadcrumbs();
			$s.lastBreadcrumbs = $s.breadcrumbs.pop();

			$s.isComplete = auditService.isCompleted();
			$s.allowWriteReport = false;

			$s.mySynchState = {};
			$s.activeFarm = {};
			$s.currentHerd = {};

			self.overViewList = [];
			self.auditQuestions = [];
			self.auditAnswers = [];
			self.prepopulatedData = {};

			

			self.dataSyncedSections = ["DATAQUALITY","REPRODUCTIVITY","FRESHCOWDISEASE"];
			self.isUsingDairyComp = false;
			self.prePopulatedDataIsLoaded = false;
			
			$s.syncInProgress = false;
			$s.isDirty = false;

			var checkPrePopulatedDataStatus = undefined;
			
			// watcher degresigration variables
			var deregOnFarmChange = undefined;
			var deregOnlineCheckWatch = undefined;

			$s.updateSyncIndicatorInterval = constant.initialUpdateSyncIndicatorInterval;

			$s.checkSyncStatusTimer = undefined;
			$s.codeFile = [];


			function loadCurrentHerd(callback){
				   
				auditService.getHerdsByFarmId(_.get($s.activeFarm,'farmId'), function getF360HerdsByFarmId(err, herd){
					  if (err) {
						  console.log('err', err);
					  }
						  $s.currentHerd =  herd[0];
                           var currentHMS = _.get($s.currentHerd,'herdMgmtSoftware');
									  //if the farm doesn't currently have the F360  module on we will want to redirect the user that got here
						  if(_.isEqual(currentHMS,'DC305')){
							 self.isUsingDairyComp = true;
						  }
                            if(_.isNull(currentHMS) || _.isUndefined(currentHMS)){
								MSF.loadPage('Login');
							 }
							 
						  callback();	 
			
					         
				});

			 
		  }
			$s.checkPermissions = function checkPermissions(callback){
			
				// we need to check to see if the user who is viewing this screen is the person who create the audit
				// otherwise we need to redirect them to the top level f360 report
				auditService.getListByHerdId($s.performanceContext,function getF360ListByHerdId(err, data) {
					 
					if(err){
						console.log("error in calling getListByHerdId (Eval Overview):  "+ err);
					}

					var currentAudit = _.find(data,{AuditId: self.auditId},'Name');

					var checkedOutToPersonId = _.get(MSF.parseJsonStringToObject(_.get(currentAudit,'CheckedOutTo','{}'),"Failed to parse CheckedOutTo in checkPermissions on Evaluation Overview."), 'PersonId');
					 // if checkedOutToPersonId is undefined then the audit is not checked out and we need to redirect the user to the top level f360 report
					 // Similarly if the audit is checked out to a different user than the current logged in one, we need to redirect the user to the top level f360 report
					if(_.isUndefined(checkedOutToPersonId) || (!_.isEqual(checkedOutToPersonId,_.get(cookies.user,'PersonId')))){
						MSF.loadPage('Fertility360report');
					}

					callback();

				});
			};
			// function that validates the PrePopulated Question Data
			function validatePrePopulatedData(data){
				var isValidData = true;
				   // if the data is either undefined or an empty array (in the case of the PrePopulated data) , then the data fails validation
				   if(_.isUndefined(data)){
					   isValidData = false;
				   }else{
					   if(_.isEmpty(data)){
						  isValidData = false;
					   }
				   }
 
				return isValidData;
			}
	    $s.loadPrePopulatedData = function loadPrePopulatedData(){
			const loadPrePopulatedDataPromise = $q.defer();
			if(self.prePopulatedDataIsLoaded === false){

				    perfMetricSvc.startTiming("Page:F360EvaluationOverviewGetIndexedDbPrePopulatedData:Request");
					auditService.getIndexedDbPrePopulatedData(self.auditId, $s.performanceContext, function getIndexedDbPrePopulatedData(err, data) {	
						perfMetricSvc.endTiming("page","Page:F360EvaluationOverviewGetIndexedDbPrePopulatedData:Request", $s.performanceContext);
						if (err) {
							log.error('error getting PrePopulatedData: ' + err);
							MSF.confirmation.danger(err,false);
						}
						
						if(self.isUsingDairyComp){
							if(validatePrePopulatedData(data)){
								self.prePopulatedDataIsLoaded = true;
								if(data.length > 0 ){
									self.prepopulatedData = data[0];
								}
								$interval.cancel(checkPrePopulatedDataStatus);
							}else{
							checkPrePopulatedDataStatus = $interval(function() {
								$s.checkPrePopulatedDataStatus();
							}, constant.timeInterval);
				
							}
						}
						$s.updateQuestionSectionDisplay();
						loadPrePopulatedDataPromise.resolve();

					});
				}else{
					loadPrePopulatedDataPromise.resolve();
				}
				return loadPrePopulatedDataPromise.promise;
		};
		$s.loadReportData = function loadReportData() {	
			const loadReportDataPromise = $q.defer();	
			
			perfMetricSvc.startTiming("Page:F360EvaluationOverviewGetIndexedDBOverViewList:Request");
			auditService.getIndexedDBOverViewList(self.auditId, $s.performanceContext, function getIndexedDBOverViewList(err, data) {
				perfMetricSvc.endTiming("page","Page:F360EvaluationOverviewGetIndexedDBOverViewList:Request", $s.performanceContext);
				if (err) {
					log.error('error getting F360 Over View List: ' + err);
					MSF.confirmation.danger(err,false);
				}
				perfMetricSvc.startTiming("Page:F360EvaluationOverview:Build");
				if (data && data.length) {
					self.overViewList = data;
					for (let index = 0; index < self.overViewList.length; index++) {
						self.overViewList[index].AnswerCnt = 0;
						self.overViewList[index].QuestionCnt = 0;
					}
					if (!window.navigator.onLine) {
						$s.$apply();
					}
				}
			
					perfMetricSvc.startTiming("Page:F360EvaluationOverviewGetIndexedDBQuestionList:Request");
					auditService.getIndexedDBQuestionList(self.auditId, $s.performanceContext, function getIndexedDBQuestionList(err, data) {
						perfMetricSvc.endTiming("page","Page:F360EvaluationOverviewGetIndexedDBQuestionList:Request", $s.performanceContext);
						if (err) {
							log.error('error getting F360 Question List: ' + err);
							MSF.confirmation.danger(err,false);
						}
					
						if (data && data.length) {
							self.auditQuestions = [];
							try{
								var parseDataQuestion = JSON.parse(data);
								var questionDetailsJson = parseDataQuestion.QuestionsJson;
								for (let i = 0; i < questionDetailsJson.length; i++) {
									self.auditQuestions.push(questionDetailsJson[i].QuestionJson[0]);
								}
							}catch(e){
								log.error("failed to parse question list json : "+_.get(e,'message'," "));
							}
							

							self.auditAnswers = [];
							perfMetricSvc.startTiming("Page:F360EvaluationOverviewGetIndexedDBAnswerList:Request");
							auditService.getIndexedDBAnswerList(self.auditId, $s.performanceContext, function getIndexedDBAnswerList(err, data) {
								perfMetricSvc.endTiming("page","Page:F360EvaluationOverviewGetIndexedDBAnswerList:Request", $s.performanceContext);
								if (err) {
									log.error('error getting F360 Over View List: ' + err);
									MSF.confirmation.danger(err,false);		
								}  
								
								if (data && data.length) {
								try{
									self.auditAnswers = JSON.parse(data);
								}catch(e){
									log.error("failed to parse answer list json : "+_.get(e,'message'," "));
								}
								
								
								} else {
									self.auditAnswers = [];
								}



								$s.loadPrePopulatedData().then(() => {
									perfMetricSvc.endTiming("page","Page:F360EvaluationOverview:Build", $s.performanceContext);
									loadReportDataPromise.resolve();
								});
								
							
							});
						}
					});
				});

				return loadReportDataPromise.promise;
			};

			 $s.getAnsweredQuestionAnswerCountOfSection = function getAnsweredQuestionAnswerCountOfSection(sectionQuestions){
				var answerCount = 0;
				for (let i = 0; i < sectionQuestions.length; i++) {
					var question = sectionQuestions[i];
					for (let j = 0; j < self.auditAnswers.length; j++) {
						if (question.QuestionId == self.auditAnswers[j].QuestionId
							&& self.auditAnswers[j].AnswerDetailsJson.Answered === true) {
							answerCount++;
						}
					}
				
				}
				return answerCount;
			 };
			 $s.getAnswerCountOfPrePopulatedCalculatedQuestions = function getAnswerCountOfPrePopulatedCalculatedQuestions(nonSyncedQuestions){
				 var answerCount = 0;
				 
				 // we need to go through each of the non synced calculated questions to see if all questions that involved in their calculations
				 // are going to be prepopulated in order to count as answered as a precounted answer. 
				 _.forEach(nonSyncedQuestions,function(nonSyncedQuestion){

	                 
					if(!_.isUndefined(_.get(nonSyncedQuestion,'QuestionDetailsJson.calculations'))){
						// first we grab the collection of calc tags that are involved in the result for this question
                         var resultCalcTags = [];
						_.forEach(_.get(nonSyncedQuestion,'QuestionDetailsJson.calculations.calculationVars',[]),function(calcVar){
							
							var calcVarObj = _.find(calcVar,'valueTag');
							
							resultCalcTags = resultCalcTags.concat(_.get(calcVarObj,'valueTag',[]));
							
						});

						 // then we need to determin if there is at least one question exists that matches the calcTag and the question is dataSynced for 
						 // every resultCalcTag.
						 // TODO: refactor to account for validation of all/total questions involved exist and are prepopulated at some point.
						 // perhaps with a count property of some kind to confirm the number of questions exist and are prepopulated per resultCalcTag 
						var allCalcValueQuestionsPrePopulated = _.every(resultCalcTags,function(resultCalcTag){
																	// check to see if one question contains a calcTag that matches the calculated question's
																	// resultCalcTag
							 										var calcTagMatch = _.find(self.auditQuestions,function(auditQuesiton){
																							 var calcTags = _.get(auditQuesiton,'QuestionDetailsJson.calcTag',[]);
																							 
																							 return _.includes(calcTags,resultCalcTag) && _.includes(_.get(auditQuesiton,'QuestionDetailsJson.dataSynced',"").toLowerCase(), 'yes');
																						 });
																	// if a match is found return true and move on to the next resultsCalcTag					 
																	 return !_.isUndefined(calcTagMatch);
																						 
						                                        });

							// if there is at least one prepopulated question with a resultCalcTag match , then we can count this question as answered
							if(allCalcValueQuestionsPrePopulated){
								answerCount++;	
							}
							

					}
		  
		  
						
				});




				 return answerCount;
			 };

			 $s.getAnswerCountWithPrePopulatedQuestions = function getAnswerCountWithPrePopulatedQuestions(sectionQuestions){
				  var answerCount = 0;
				  var prePopulatedFields = _.get(self.prepopulatedData,'PrePopFields',[]);
				  
				  // first we need to get the questions that are supposed to be datasynced for this section for their total count later
				  var prePopulatedQuestions =  _.filter(sectionQuestions,function(question){
											
												   var dataSynced = _.get(question,'QuestionDetailsJson.dataSynced'); 
												 
												   return _.includes(dataSynced.toLowerCase(), 'yes');
												    
											   });
				
				  
                  // if there are prepopulated questions in this section we need to further determine what the answer count will be
				  if(prePopulatedQuestions.length > 0){

					// next we need to determine if the answers for preopulated questions have already been answered. we only need to check the first prePopulatedQuestion as all prePopulatedQuestions
					// are answered when a user enters into a question section
					var answerMatch = _.find(self.auditAnswers,{QuestionId: _.get(prePopulatedQuestions[0],'QuestionId')});
					 
					// if the prePopulatedQuestions were already answered then we need to count the answers as normal
					if(!_.isUndefined(answerMatch)){
						answerCount = $s.getAnsweredQuestionAnswerCountOfSection(sectionQuestions);  
					}else{
					    //otherwise answer count is the sum of the number of PrePopulatedQuestions
					   
					    answerCount += prePopulatedQuestions.length;
					   
					    // but we also need to be able to count questions that are not data synced from prepopulated data , but are a calculated result from questions that are prepopulated.  	 						   
						var calculatedQuestionCount = 0; 
						var nonPrePopulatedQuestions = _.difference(sectionQuestions,prePopulatedQuestions);

						if(nonPrePopulatedQuestions.length > 0){
							calculatedQuestionCount += $s.getAnswerCountOfPrePopulatedCalculatedQuestions(nonPrePopulatedQuestions);
							answerCount += calculatedQuestionCount;
						}  
					}

					
				  }else{
					  // otherwise the answer count is determined as normal
					  answerCount = $s.getAnsweredQuestionAnswerCountOfSection(sectionQuestions);
				  }
				  



				  return answerCount;


			 };

	         $s.updateQuestionSectionDisplay = function updateQuestionSectionDisplay(){
				var completeSectionsCount = 0;
				for (let index = 0; index < self.overViewList.length; index++) {
					self.overViewList[index].AnswerCnt = 0;
					var sectionQuestions = _.filter(self.auditQuestions, {Section: self.overViewList[index].Section});
				
					//----------------------------------------------------------------------------------------------
					//this section  should be refactored at some point. It is a hardcode logic needed because the disabling of the questions in a subheading was implimented
					//as a question itself instead of a field of the subheading. 
					var notApplicableQuestion = _.find(sectionQuestions, function(question) {
						  return _.isEqual(question.SubHeading,"Dry Cows Far-Off") && _.isEqual(question.QuestionTemplate,"TF");
						
						});
				    var excludedQuestionIds = [];
                    // first we want to add all of the questions we are that have hideOnScrnUI == true
					excludedQuestionIds = _.union(excludedQuestionIds,_.pluck(_.filter(sectionQuestions,{QuestionDetailsJson: {hideOnScrnUI : true}}),'QuestionId'));

				   if(!_.isUndefined(notApplicableQuestion)){
					    excludedQuestionIds.push(_.get(notApplicableQuestion,'QuestionId'));
						var notApplicableQuestionAnswer = _.find(self.auditAnswers,"QuestionId",notApplicableQuestion.QuestionId);	
						if(_.isEqual(_.get(notApplicableQuestionAnswer,'AnswerDetailsJson.Value',constant.answerFalse),constant.answerTrue) && _.isEqual(notApplicableQuestion.Section,self.overViewList[index].Section)){
							//if the not applicable TF question is true (checked), we first want to exclude any calculated question that is dependent on the questions in the not applicable TF question's subheading
							
							 var subHeadingQuestions = _.filter(sectionQuestions,{SubHeading: notApplicableQuestion.SubHeading});
							 _.forEach(subHeadingQuestions,function(subHeadingQuestion){
								var calcTags = _.get(subHeadingQuestion,'QuestionDetailsJson.calcTag',null);
								
								if(!_.isNull(calcTags)){
									_.forEach(calcTags,function(calcTag){
									   
										var calcQuestion = _.find(sectionQuestions,function(question){ 
															
																var calcVarArray = _.get(question,'QuestionDetailsJson.calculations.calculationVars');
																if(!_.isUndefined(calcVarArray) && !_.isEmpty(calcVarArray)){
																		var valueTagObjects = [];

																		_.forEach(calcVarArray,function(calcVarObject){
																			var calcVarObjectKey = _.keys(calcVarObject)[0];
																			valueTagObjects.push(calcVarObject[calcVarObjectKey]);		
																		});
																		var calcQuestionMatch = false;
																		_.forEach(valueTagObjects,function(valueTagObject){
																			if(_.isEqual(subHeadingQuestion.SubHeading,valueTagObject.subHeading) && _.includes(valueTagObject.valueTag,calcTag)){
																				calcQuestionMatch = true;
																				return false;		
																			}

																		});


																		return calcQuestionMatch;
																}
															 
																
															});
										   if(!_.isUndefined(calcQuestion) && !_.includes(excludedQuestionIds,calcQuestion.QuestionId)){
											   excludedQuestionIds.push(calcQuestion.QuestionId);
										   }	
									});
								}

								excludedQuestionIds.push(_.get(subHeadingQuestion,'QuestionId'));
								
							 });   
						   
						}	   
				   }
				   
				   
				   sectionQuestions = _.reject(sectionQuestions,function(question){ return _.includes(excludedQuestionIds,question.QuestionId);});
						
				  //-------------------------------------------------------------------------------------------------    
	
					self.overViewList[index].QuestionCnt = sectionQuestions.length;
				//	var reviewComplete = localStorage.getItem(self.auditId + "_complete_"+ self.overViewList[index].Section);
				//	self.overViewList[index].ReviewComplete = reviewComplete;

					// Next we need to determin the answer count for the section. For the sections that have prepopulated data that answer count will either be 
					// the number of matches the section has with the prepopulated data or the actual answered question count of the section. 
                    // Quesiton sections that do not contain preopulated questions or the herds HMS is not  Dairy Comp , the answer count will equal the number of answered questions. 
					var answerCount = 0; 

					
					if(self.isUsingDairyComp){
						 
						answerCount = $s.getAnswerCountWithPrePopulatedQuestions(sectionQuestions);

					}else{
						answerCount = $s.getAnsweredQuestionAnswerCountOfSection(sectionQuestions);
					}
					
					
                    
					self.overViewList[index].AnswerCnt = answerCount;
					if (self.overViewList[index].AnswerCnt == self.overViewList[index].QuestionCnt) {
						completeSectionsCount++;
					}
					
					if (completeSectionsCount == self.overViewList.length && allSectionsReviewed()) {
						$s.allowWriteReport = true;
					}
					if (!$s.$$phase) {
						$s.$digest();
					}
					if (!window.navigator.onLine) {
						$s.$apply();
					}
					
				  }
				  
			 };
			
			

            $s.openSection = function(section){
				if( ((self.isUsingDairyComp === false && $s.currentHerd.herdMgmtSoftware != 'DC305') || ((!_.includes(self.dataSyncedSections,section)) || (self.isUsingDairyComp === true && self.prePopulatedDataIsLoaded === true)))
					&& ($s.syncInProgress === false)){
                    
					$window.location.href = "#/f360/"+self.auditId+"/evaluation-overview/"+$filter("SectionLink")(section); //{{itemOverView.Section | SectionLink}}"
				}
					
				
			};

			$s.sectionContainsSyncedQuestions = function sectionContainsSyncedQuestions(section){

				var sectionQuestions = _.filter(self.auditQuestions, {Section: section});
                
				var prePopulatedQuestions =  _.filter(sectionQuestions,function(question){
											
												var dataSynced = _.get(question,'QuestionDetailsJson.dataSynced'); 
											
												return _.includes(dataSynced.toLowerCase(), 'yes');
												
											});
				return prePopulatedQuestions.length > 0;

			};
			$s.sectionContainsOnlySyncedQuestions = function sectionContainsSyncedQuestions(section){

				var sectionQuestions = _.filter(self.auditQuestions, {Section: section});
                
				var containsOnlySyncedQuestions =  _.all(sectionQuestions,function(question){
											
												var dataSynced = _.get(question,'QuestionDetailsJson.dataSynced'); 
											
												return _.includes(dataSynced.toLowerCase(), 'yes');
												
											});
				return containsOnlySyncedQuestions;

			};
			function allSectionsReviewed(){
				var allsectionsReviewed = false;
				allsectionsReviewed = _.all(self.overViewList,function(section){
					                       return _.get(section,'ReviewComplete',false); 
									   });
			    return allsectionsReviewed;
			}

			$s.allQuestionsAnswered = function(section){
				var allQuestionsAnswered = false;
				var questionCount = _.get(section,'QuestionCnt',0);
				var answerCount = _.get(section,'AnswerCnt',0);
				
				allQuestionsAnswered = _.isEqual(questionCount,answerCount) && questionCount > 0;
				
				return allQuestionsAnswered;
			};

			$s.completionPercent = function completionPercent(cntAnswer, cntQuestion, section) {
				// if the farm is using dairy comp we need to check to see if the PrePopulatedData has loaded
				if( self.isUsingDairyComp === true){
					
					// if the data has loaded , show the green bar progress as normal
					if(self.prePopulatedDataIsLoaded === true || !$s.sectionContainsSyncedQuestions(section)){
					
						var percent = (cntAnswer/cntQuestion)*100;
						return Math.round(percent);
					}else{
						// otherwise return 0 to not show the green bar until the Answer/Question counts for sections with PrePopulated Data 
						// can be updated.
						return 0;
					}
					
					
				}else{
				    // non dairy comp farms show the green bar progress as normal	
					var percent = (cntAnswer/cntQuestion)*100;
					return Math.round(percent);
					
				}
					
			};

			$s.checkPrePopulatedDataStatus = function(){
				if(!self.prePopulatedDataIsLoaded){
					auditService.getIndexedDbPrePopulatedData(self.auditId, function getIndexedDbPrePopulatedData(err, data) {
						if (err) {
							log.error('error getting PrePopulatedData: ' + err);
							MSF.confirmation.danger(err,false);
						}
						if(validatePrePopulatedData(data)){

								self.prePopulatedDataIsLoaded = true;
								if(data.length > 0 ){
									self.prepopulatedData = data[0];
									$s.updateQuestionSectionDisplay();
								}
								
								
								$interval.cancel(checkPrePopulatedDataStatus);
							
						}
					});
				}
			};

		   $s.syncingBackOnline = false;
		   
	       deregOnlineCheckWatch =	$s.$on('online:change',function(event,onLineChange){
			
				   var onLineValue = _.get(onLineChange,'value');
				   var isOnlineOldValue =  angular.copy($s.isOnline);
				   $s.isOnline = onLineValue; 
				   // if the device was previously offline and now back online
				// we need to see if we will run checkF360SyncStatus
				if(isOnlineOldValue === false && onLineValue === true){
                     if($s.syncingBackOnline === false){
						 $s.syncingBackOnline = true;
						 $s.syncInProgress = true;
						 $s.checkF360SyncStatus().then(function(){
							$s.syncingBackOnline = false;
							$s.syncInProgress = false;
							self.isSync = true;
						 });
					 } 
				}
				if(onLineValue === false){
					self.isSync = false;
					$s.$apply();
				}
				
			});
			

			$s.checkF360SyncStatus = function checkF360SyncStatus() {
				var syncStatusPromise = $q.defer();

				if ($s.isOnline) {

					log.info("Evaluation Overview : checkSync: Synch in Progress");

					auditService.getIndexDBListByHerdId(function getF360List(err, data){

						
						if(err){
							log.error("There was err in getting cached audit list : "+err);
							syncStatusPromise.reject(true);
							MSF.loadPage('Fertility360report');
						}

						var activeAuditListData = _.find(data,{AuditId: self.auditId});
						var lastSyncedDate = _.get(activeAuditListData,'SyncedOn',null);
						if(_.isEqual(lastSyncedDate,"")){
							lastSyncedDate = null;
						}
							
				       var  isDeviceDirty = _.get(activeAuditListData,'IsDeviceDirty',false);

					 //  log.info("check Sync: calling getSyncStatus with lastSyncedDate: "+lastSyncedDate+" and isDeviceDirty: "+isDeviceDirty);
					   perfMetricSvc.startTiming("Page:F360EvaluationOverviewGetSyncStatus:Request");
					   api.getSyncStatus(self.auditId,lastSyncedDate,isDeviceDirty, $s.performanceContext, function getF360SyncStatus(err, data) {
								perfMetricSvc.endTiming("page","Page:F360EvaluationOverviewGetSyncStatus:Request", $s.performanceContext);
								if (err) {
									log.error('error getting sync check: ' + err);
								}
								
								if (data) {
								
									var syncData = data;	

									if(!_.isUndefined(syncData)){
										if((_.isEqual(_.get(syncData,'ToUpdateServer'),true)) || (_.isEqual(_.get(syncData,'ToUpdateServer').toLowerCase(),"true"))){
											auditService.updateServerAuditData(self.auditId,function(err,data){
												if (err) {
													log.error('error updating server with device data: ' + err);
													$s.isDirty = true;
												}else{
													$s.isDirty = false;
												}
												log.info("update server complete");
												// we need to update the IsDeviceDirty flag of the audit in IndexDB
												auditService.updateIsDirty(self.auditId,$s.isDirty,function getIsDirtyUpdate(err, data){
													if (err) {
														log.error('error updateing isDirty flag: ' + err);
													}
													log.info("checkedSync: update IsDeviceDirty complete");
													// we need to call up the database version of SyncedOn because the update server proccess sets a more current SyncedOn on the server side
													auditService.getListByHerdId($s.performanceContext, function getF360ListByHerdId(err, data) {
														var auditlistItem = _.find(data,{AuditId: self.auditId});
	
														 //if the audit was deleted ,the record won't be in IndexedDB and doesn't need SyncedOn updated
														if(!_.isUndefined(auditlistItem)){ 
															auditService.updateLastSyncedDate(self.auditId,_.get(auditlistItem,'SyncedOn'),function getUpdateLastSyncDateData(err,data){
																if (err) {
																	log.error('error updating server with device data: ' + err);
																}
																
																log.info("checkedSync: last synced date update complete , sync end");
																syncStatusPromise.resolve(true);
			
															});	 
														}else{
															log.info("checkedSync: audit was deleted . so no need to update last synced date. sync end ");
															syncStatusPromise.resolve(true);
														}
		
													});
												});
												
												
	
											});
										}else{
										   // the device's SyncedOn Date is older than the server's copy of the same property and the device needs updating
											log.info("checkSync: server is up to date , need to check if device needs updating");
												if((_.isEqual(_.get(syncData,'ToUpdateDevice'),true)) || (_.isEqual(_.get(syncData,'ToUpdateDevice').toLowerCase(),"true"))){
													log.info("checkSync: device needs updating , setting device update flag true , sync end");
												
													 // if the device needs updating then we need to send the user back to the f360 dashboard to attempt a device sync after prompt
													 
													syncStatusPromise.reject(true);
													MSF.loadPage('Fertility360report');
												}else{
													log.info("checkSync: no server update needed , sync end");
													syncStatusPromise.resolve(true);
												}
											  
										}
									} else {
										log.info("checkedSync: no getSyncedStatus data returned , sync end");
									    syncStatusPromise.resolve(true);
									}

								} else {
								    syncStatusPromise.resolve(true);
								}	
							});
						});
				} else {
				  syncStatusPromise.resolve(true);
				}
			  return syncStatusPromise.promise;
			};
			
			$s.$on("$destroy", function() {
				window.onblur = undefined;
				window.onfocus = undefined;
				deregOnFarmChange();
				deregOnlineCheckWatch();
			
				if(self.isUsingDairyComp){
					$interval.cancel(checkPrePopulatedDataStatus);
				}

				$s.performanceContext = null;
		
			});
		
			deregOnFarmChange =	$s.$on('farm:changed',function(){
									MSF.loadPage('Fertility360report');
								});

			MSF.ready(function onMsfReady() {
				$s.performanceContext = perfContextSvc.createPerformanceContext(_.get(MSF.getActiveHerd(),'herdId',null));
				$s.codeFile = _.cloneDeep(_.get(MSF,'lists.codeFile',[]));
				//local storage data 	
				var mySynchStateJSON = localStorage.getItem('MySynch-state');
				if(!_.isUndefined(mySynchStateJSON)){
					$s.mySynchState = JSON.parse(mySynchStateJSON);

					$s.activeFarm = _.get($s.mySynchState,'value.activeFarm',{});
				}
				auditService.getActiveOrCurrentAuditVersion($s.performanceContext).then(function(apiVersion){
					$s.auditApiVersion = apiVersion;
			    });
                

				// first we want to check if the user has permissions to view this page/audit
				$s.checkPermissions(function(){
					// then we have to check if the server or the device needs updating 
					$s.syncInProgress = true;
					$s.checkF360SyncStatus().then(function(){
						
						// then as long as the user wasn't kicked back to the dashboard, continue to load this screen's data
						$s.syncInProgress = false;	
						
						perfMetricSvc.startTiming("Page:F360EvaluationOverview:Render");
					 	loadCurrentHerd(() => {
							$s.loadReportData().then(() => {
								perfMetricSvc.markPageReady("Page:F360EvaluationOverview:Render", $s.performanceContext);
							});
						 });				
					 	
						
	
					});
				});
						
			});
								
		}
	]);
})();
